
























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { UserStateModule } from '@/store';
import { CONSTANTS } from '@/core';
import { AccountModel, FileUploadModel } from '../../type';
import { MembersService } from '@/kuroco_api/services/MembersService';
import { Uploader, UploaderFactory } from '@/kuroco_api/core/Uploader';
import isEmpty from 'lodash/isEmpty';

@Component<ProfileEdit>({})
export default class ProfileEdit extends Vue {
  // PROPS
  @Prop({
    type: Boolean,
    required: true,
    default: false,
  })
  shows!: boolean;

  // FIELDS
  uploader!: Uploader;
  UserStateModule = UserStateModule;
  userName = '';
  postingState = 'PRE';
  file?: File;
  memberPhoto: Partial<MemberPhoto> = {};

  // MUTATIONS
  get isLoading() {
    return this.postingState === 'LOADING';
  }
  get imgButtonStyle() {
    return this.postingState === 'COMPLETE'
      ? {
          opacity: 0.3,
          cursor: 'pointer',
        }
      : { opacity: 0, cursor: 'unset' };
  }
  get avatarImage(): string {
    return !!this.memberPhoto.file_id ? window.URL.createObjectURL(this.file) : this.myAvatarSrc;
  }
  get myAvatarSrc(): string {
    return this.UserStateModule.myImage;
  }

  // METHODS
  async handleChangeFileInput(e: Event) {
    const newFile = (e.target as any).files[0];
    if (newFile === undefined) {
      return;
    }

    // checking whether this file have a proper extension.
    const properExts = [CONSTANTS.UPLOADABLE_FILETYPE_DEF.PNG, CONSTANTS.UPLOADABLE_FILETYPE_DEF.JPEG]
      .map((def) => def.exts)
      .flat(1);
    if (!properExts.includes(newFile.name.split(/\./g).pop())) {
      window.alert(`${newFile.name} ` + this.$t('invaild_image'));
      return;
    }

    this.postingState = 'LOADING';

    const { file_id } = await this.uploader.upload(newFile).catch((e) => {
      this.postingState = 'ERROR';
      this.$snack.danger({ text: this.$t('error_occurred') });
      return Promise.reject();
    });

    this.file = newFile;
    this.memberPhoto = {
      file_id,
      desc: newFile.name,
    };
    this.postingState = 'PRE';
  }
  handleClickSubmit(e: Event) {
    if (!this.userName || this.userName === '') {
      window.alert(this.$t('dont_empty_user_name'));
      return;
    }

    const query: MembersService.postMembersServiceRcmsApi1MemberUpdateRequest = {
      requestBody: { nickname: this.userName },
    };
    if (!isEmpty(this.memberPhoto)) {
      query.requestBody.image = this.memberPhoto;
    }

    this.postingState = 'LOADING';
    UserStateModule.updateUser(query)
      .then(() => {
        this.postingState = 'COMPLETE';
        this.$snack.show({ text: this.$t('updated') });
      })
      .catch((e) => {
        this.postingState = 'ERROR';
        this.$snack.danger({ text: this.$t('error_occurred') });
      });
  }
  async uploadImageToStorage(file: File) {
    return await this.uploader.upload(file);
  }

  // LIFECYCLE HOOKS
  async mounted() {
    this.uploader = await UploaderFactory.create({});
    this.userName = this.UserStateModule.selfUser.nickname;
  }
}

interface MemberPhoto {
  file_id: string;
  desc: string;
}
